// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
import { BootstrapStoreProvider } from '../bootstrap-store-provider';

// This barrel file is temporary and allows PRs for implementation to not have diffs on `bootstrap-store-provider` to ensure safe PRs
export { type BootstrapContainerProps } from '../bootstrap-store-provider';
export default BootstrapStoreProvider;
